import axios from 'axios'
import Vue from 'vue'


export default {
    namespaced: true,
    state: {
        //currentUser: getSavedState('auth.currentUser'),
        token: getSavedState('auth.token'),
        username: '',
        logoutFlag: false,
        employee: null
    },
    mutations:
    {
        SET_LOGOUT_FLAG(state, value) {
            state.logoutFlag = value;
        },
        SET_CURRENT_USER(state, newValue) {
            //if (newValue != null) {
            //    state.tokens = {
            //        token: newValue.token,
            //        refreshToken: newValue.refreshToken
            //    };
            //    state.username = newValue.username;
            //}
            //state.currentUser = newValue;'
            if (newValue == null) {
                state.token = null;
                state.username = null;
                saveState('auth', null);
                state.employee = null;

            } else {
                state.token = newValue.token;
                state.username = newValue.username;
                saveState('auth', { token: newValue.token, user: newValue.username });
                console.log(newValue);
                state.employee = newValue.employee;
                //setDefaultAuthHeaders(state);
            }

        }   
    },
    getters: {
        loggedIn(state) {
            //console.log("looooooooooooogedIn");
            //let logged = !!state.token;
            //console.log(logged);
            //return logged;
            let isLogged = !!state.token;
            return isLogged;
            return true;
        }
    },
    actions: {

        init({ state, dispatch, getters }) {
            
            //dispatch("logOut");
           // setDefaultAuthHeaders(state)
            //dispatch('validate')
        },
        setUser({ commit },data ) {
            commit('SET_CURRENT_USER', data);
        },
        setLogoutFlag({ commit }, data) {
            commint('SET_LOGOUT_FLAG', data);
        },
        // Logs in the current user.
        logIn({ commit, dispatch, getters }, { username, password, sessionId } = {}) {

            
            //if (getters.loggedIn) return dispatch('validate')

            return axios
                .post('/api/account/login', { Username: username, Password: password, SessionId:sessionId })
                .then((response) => {
                    if (!response.data.failed) {

                        //const data = {
                        //    username: response.data.user,
                        //    token: response.data.token,
                        //    refreshToken: response.data.refreshToken,
                        //    sessionId: response.data.sessionId
                        //};
                        
                        commit('SET_CURRENT_USER', response.data.payload)
                        //Vue.prototype.$pp.populate(response.data.permissions);
                        //dispatch("users/setUserPermissions", response.data.permissions);
                    }
                    return response;
                }).catch(err => {
                    console.log(err);
                })
        },
        setPermissions({ }, permissions) {
            Vue.prototype.$pp.populate(permissions);
        },
        // Logs out the current user.
        logOut({ commit }) {
            commit('SET_CURRENT_USER', null);
            commit('SET_LOGOUT_FLAG');
            return axios.post('api/account/logout');
        },

        // register the user
        register({ commit, dispatch, getters }, { fullname, email, password } = {}) {
            if (getters.loggedIn) return dispatch('validate')

            return axios
                .post('/api/register', { fullname, email, password })
                .then((response) => {
                    const user = response.data
                    return user
                })
        },

        // register the user
        resetPassword({ commit, dispatch, getters }, { email } = {}) {
            if (getters.loggedIn) return dispatch('validate')

            return axios
                .post('/api/reset', { email })
                .then((response) => {
                    const message = response.data
                    return message
                })
        },


        refreshToken({ commit, state }) {

            let sessionData = getSavedState("auth.currentUser");
            return axios
                .post('/api/account/refresh',
                    { token: sessionData.token, refreshToken: sessionData.refreshToken })
                .then((response) => {
                    if (response.data.status == 1) {
                        const data = {
                            username: sessionData.user,
                            token: response.data.token,
                            refreshToken: response.data.refreshToken,
                            sessionId: sessionData.sessionId
                        };
                        commit('SET_CURRENT_USER', data)
                        return true;

                    } else {
                        return false
                    }
                }).catch(err => {
                    console.log(err);
                    return false
                })

        },
        isLogged({ commit, state }) {
        },
        // Validates the current user's token and refreshes it
        // with new data from the API.
        validate({ commit, state }) {
            //let sessionData = getSavedState("auth.token");
            if (Vue.prototype.$pp != undefined && Vue.prototype.$pp.initiated) {
                return true;
            } else {

                return axios
                    .post('/api/account/IsLogged')
                    .then((response) => {

                        if (response.data.status == 1) {
                            //const user = response.data
                            //commit('SET_CURRENT_USER', user)
                            Vue.prototype.$pp.populate(response.data.permissions);
                            return true;
                        } else {
                            commit('SET_CURRENT_USER', null)
                            return false;
                        }
                        
                        return user
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 401) {
                            commit('SET_CURRENT_USER', null)
                            return false;
                        }
                        return null
                    })
            }
        },
    }
}
// ===
// Private helpers
// ===

function getSavedState(key) {
    return JSON.parse(window.sessionStorage.getItem(key))
}

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}



function setDefaultAuthHeaders(state) {
    //console.log(state.currentUser);
    //console.log("SET AXIOS HEADER");
    //axios.defaults.headers.common.Authorization = state.currentUser
    //    ? "Bearer " + state.currentUser.token
    //: ''
}
